import {
  AccessRuleItems,
  AddProductsToDomainBody,
  DomainProducts,
  ExclusionItem,
  UpdateAccessRuleBody,
} from '../../../shared/models/AccessRule';
import emptySliceApi from '../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccessRule: builder.query<
      AccessRuleItems[],
      { accountId: string; providerNumber: string }
    >({
      query: ({ accountId, providerNumber }) =>
        `v4/accessrules/account/${accountId}/provider/${providerNumber}`,
      providesTags: ['AccessRule'],
    }),
    getDomainProducts: builder.query<
      DomainProducts[],
      { accountId: string; providerNumber: string; accessRuleId: number }
    >({
      query: ({ accountId, providerNumber, accessRuleId }) =>
        `v4/accessrules/account/${accountId}/provider/${providerNumber}/accessruleproduct/${accessRuleId}`,
      providesTags: ['DomainProducts'],
    }),
    addProductsToDomain: builder.mutation<
      DomainProducts[],
      AddProductsToDomainBody
    >({
      query: (body) => ({
        url: `v4/accessrules/account/${body.accountNumber}/provider/${body.providerNumber}/accessruleproduct`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['DomainProducts'],
    }),
    toggleDomainAccess: builder.mutation<
      AccessRuleItems,
      { body: UpdateAccessRuleBody }
    >({
      query: ({ body }) => ({
        url: `v4/accessrules/account/${body.accountNumber}/provider/${body.providerNumber}/accessRule/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AccessRule'],
    }),
    addExclusion: builder.mutation<
      ExclusionItem[],
      {
        accountNumber: string;
        providerNumber: string;
        body: { exclusions: ExclusionItem[] };
      }
    >({
      query: ({ accountNumber, providerNumber, body }) => ({
        url: `v4/accessrules/account/${accountNumber}/provider/${providerNumber}/exclusion/bulk`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AccessRule'],
    }),
    removeExclusion: builder.mutation<
      void,
      {
        accountNumber: string;
        providerNumber: string;
        body: { exclusionIds: number[] };
      }
    >({
      query: ({ accountNumber, providerNumber, body }) => ({
        url: `v4/accessrules/account/${accountNumber}/provider/${providerNumber}/exclusion/bulk`,
        method: 'DELETE',
        body,
      }),
      invalidatesTags: ['AccessRule'],
    }),
  }),
});

export const {
  useGetAccessRuleQuery,
  useGetDomainProductsQuery,
  useAddProductsToDomainMutation,
  useToggleDomainAccessMutation,
  useAddExclusionMutation,
  useRemoveExclusionMutation,
} = apiSlice;
